<div class="modal-header">
	<h5 class="modal-title">Sammelbearbeitung</h5>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="cancel()"></button>
</div>

<div class="modal-body">
	<!-- Step-Indikator: Nummer (Kreis) + Label getrennt, damit alle Chips gleich hoch sind
	     und einzeilig bleiben — vorher franste der Text je nach Label-Länge unterschiedlich aus. -->
	<ol class="wizard-steps">
		<li [class.active]="step === 'auswahl'"     [class.done]="['felder','operationen','preview','ausfuehrung','abgeschlossen'].includes(step)">
			<span class="step-num">1</span><span class="step-label">Auswahl</span>
		</li>
		<li [class.active]="step === 'felder'"      [class.done]="['operationen','preview','ausfuehrung','abgeschlossen'].includes(step)">
			<span class="step-num">2</span><span class="step-label">Felder</span>
		</li>
		<li [class.active]="step === 'operationen'" [class.done]="['preview','ausfuehrung','abgeschlossen'].includes(step)">
			<span class="step-num">3</span><span class="step-label">Operationen</span>
		</li>
		<li [class.active]="step === 'preview'"     [class.done]="['ausfuehrung','abgeschlossen'].includes(step)">
			<span class="step-num">4</span><span class="step-label">Vorschau</span>
		</li>
		<li [class.active]="step === 'ausfuehrung' || step === 'abgeschlossen'">
			<span class="step-num">5</span><span class="step-label">Ausführung</span>
		</li>
	</ol>

	<!-- Lade-Spinner: parent ruft `start()` auf, sobald queryIndex zurück ist. -->
	<section *ngIf="loading" class="step-content loading-overlay">
		<div class="spinner-border text-primary" role="status" aria-label="Lade Punkte"></div>
		<p class="text-muted small mt-2 mb-0">Punkte werden geladen…</p>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 1: Auswahl -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="!loading && step === 'auswahl'" class="step-content">

		<!-- Pfad-Auswahl ganz oben (nach oben gezogen): erst entscheidet der Nutzer, was er
		     mit der Auswahl tun will; die Punktmenge verfeinert er darunter im Auswahl-Block. -->
		<div class="path-chooser">
			<div class="path-chooser-head">
				Was möchtest du mit den
				<strong>{{ selectedPoints.length }}</strong> ausgewählten Punkten tun?
			</div>
			<div class="path-cards">

				<!-- Pfad 1: Felder ändern (Hauptweg, bleibt im Assistenten) -->
				<div class="path-card path-1">
					<div class="path-card-badge">Pfad 1</div>
					<div class="path-card-title">
						<i class="bi bi-pencil-square" aria-hidden="true"></i>
						Felder ändern
					</div>
					<div class="path-card-desc">
						Feldwerte per Operation (Setzen, Ersetzen, Zuordnen …) für die ganze Auswahl ändern.
					</div>
					<button type="button" class="btn btn-sm btn-primary path-card-action"
							[disabled]="selectedPoints.length === 0"
							title="Mit der Feld-Auswahl im Assistenten fortfahren"
							(click)="goNext()">
						Weiter →
					</button>
				</div>

				<!-- Pfad 2: Projekt-Workflow-Editor öffnen (Sackgasse) — Heim der Bulk-Status-Aktionen -->
				<div class="path-card path-2">
					<div class="path-card-badge">Pfad 2</div>
					<div class="path-card-title">
						<i class="bi bi-diagram-3" aria-hidden="true"></i>
						Status-Workflow
					</div>
					<div class="path-card-desc">
						Öffnet den Workflow-Editor des Projekts. Über das Status-Diagramm darin ziehst du Punkte sammelweise durch die Workflow-Status (Greifen, In den Pool zurückgeben, Vorlegen, Annehmen, Abschließen …).
					</div>
					<button type="button" class="btn btn-sm btn-outline-primary path-card-action"
							title="Projekt-Workflow-Editor öffnen (Bulk-Statuswechsel) — schließt diesen Assistenten"
							(click)="openWorkflowEditor()">
						Öffnen →
					</button>
				</div>

				<!-- Pfad 3: WMS-Daten abrufen (Sackgasse) -->
				<div class="path-card path-3">
					<div class="path-card-badge">Pfad 3</div>
					<div class="path-card-title">
						<i class="bi bi-arrow-repeat" aria-hidden="true"></i>
						WMS-Daten abrufen
					</div>
					<div class="path-card-desc">
						Klimastufe, Forst-/Katasteradresse und Wuchsgebiet via WMS neu abrufen — sequentiell, IP-Sperr-bewusst.
					</div>
					<button type="button" class="btn btn-sm btn-outline-primary path-card-action"
							[disabled]="selectedPoints.length === 0"
							title="WMS-Lauf für die ausgewählten Punkte öffnen — schließt diesen Assistenten"
							(click)="startWmsRefresh()">
						Öffnen →
					</button>
				</div>

			</div>
		</div>

		<!-- Filter-/Auswahl-Block: visuell als zusammengehörige Einheit abgehoben.
		     Hier wird die Punktmenge bestimmt, mit der danach einer der drei Pfade läuft. -->
		<div class="selection-block">
			<div class="selection-block-header">
				<i class="bi bi-funnel-fill" aria-hidden="true"></i>
				<span>Punktauswahl &amp; Filter</span>
			</div>

			<h6 class="selection-subhead">Quelle wählen</h6>
			<div class="source-row mb-2">
				<div class="btn-group btn-group-sm" role="group" aria-label="Quelle">
					<button *ngFor="let s of sourceOptions"
							type="button"
							class="btn"
							[class.btn-primary]="sourceId === s.id"
							[class.btn-outline-secondary]="sourceId !== s.id"
							[disabled]="!s.available"
							[title]="s.available ? s.label : s.label + ' (nicht verfügbar)'"
							(click)="applySource(s.id)">
						{{ s.label }}
						<span class="badge bg-light text-dark ms-1">{{ s.count }}</span>
					</button>
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary ms-2"
						(click)="openFilterEditor()"
						title="Filter bearbeiten oder neu definieren">
					Filter bearbeiten…
				</button>
			</div>
			<p class="text-muted small mb-2">
				{{ points.length }} Punkte in dieser Quelle —
				{{ selectedPoints.length }} sind aktiviert. Per Schnellfilter eine Gruppe
				eingrenzen oder einzelne Punkte abwählen.
			</p>

			<div class="quick-filter mb-2">
				<span class="form-label small mb-0 me-2">Schnellfilter:</span>
				<div class="btn-group btn-group-sm" role="group" aria-label="Schnellfilter">
					<button *ngFor="let opt of quickFilterOptions"
							type="button"
							class="btn"
							[class.btn-primary]="quickFilter === opt.id"
							[class.btn-outline-secondary]="quickFilter !== opt.id"
							[disabled]="(quickFilterCounts.get(opt.id) ?? 0) === 0 && opt.id !== 'all'"
							[title]="opt.label"
							(click)="applyQuickFilter(opt.id)">
						{{ opt.label }}
						<span class="badge bg-light text-dark ms-1">{{ quickFilterCounts.get(opt.id) ?? 0 }}</span>
					</button>
				</div>
			</div>

			<div class="point-list">
				<div *ngFor="let p of points; trackBy: trackByPointId" class="form-check">
					<input class="form-check-input"
						   type="checkbox"
						   [id]="'chk-' + p._id"
						   [title]="'Punkt ' + (p.header.nummer || p._id)"
						   [checked]="!excludedPointIds.has(p._id)"
						   (change)="togglePointExclusion(p._id)">
					<label class="form-check-label" [for]="'chk-' + p._id">
						<strong>{{ p.header.nummer || p._id }}</strong>
						<span class="text-muted small ms-2">{{ p.header.revier }}</span>
					</label>
				</div>
			</div>
		</div>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 2: Felder -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="step === 'felder'" class="step-content">
		<div class="field-step-header">
			<h6 class="mb-0">Welche Felder sollen geändert werden?</h6>
			<span class="text-muted small ms-auto">Ausgewählt: {{ selectedFieldKeys.size }}</span>
		</div>

		<div class="field-search mb-2">
			<i class="bi bi-search field-search-icon" aria-hidden="true"></i>
			<input type="text"
				   class="form-control form-control-sm field-search-input"
				   placeholder="Feld filtern…"
				   title="Felder nach Label oder Schlüssel filtern"
				   aria-label="Felder filtern"
				   [ngModel]="fieldFilter"
				   (ngModelChange)="fieldFilter = $event; onFieldFilterChange()">
			<button *ngIf="fieldFilter"
					type="button"
					class="btn btn-sm btn-link field-search-clear"
					title="Filter löschen"
					aria-label="Filter löschen"
					(click)="fieldFilter = ''; onFieldFilterChange()">
				<i class="bi bi-x"></i>
			</button>
		</div>

		<div *ngIf="displayedGroupedFields.length === 0 && !bestandFilterMatch" class="text-muted small fst-italic">
			Keine Felder passen zum Filter.
		</div>

		<div *ngFor="let grp of displayedGroupedFields" class="field-group-card">
			<div class="field-group-header">{{ grp.group }}</div>
			<div class="field-grid">
				<label *ngFor="let f of grp.fields"
					   class="field-cell"
					   [ngbTooltip]="f.hint || null"
					   container="body"
					   placement="top"
					   [openDelay]="400">
					<div class="field-cell-row">
						<input class="form-check-input field-cell-check"
							   type="checkbox"
							   [id]="'field-' + f.key"
							   [checked]="selectedFieldKeys.has(f.key)"
							   (change)="toggleField(f.key)">
						<span class="field-cell-text">{{ f.label }}</span>
						<ng-container *ngIf="typeTagFor(f.type) as tag">
							<span class="type-tag" [class.type-tag-mono]="tag.kind === 'mono'">
								<ng-container *ngIf="tag.kind === 'mono'">{{ tag.value }}</ng-container>
								<i *ngIf="tag.kind === 'icon'" [class]="'bi ' + tag.value" aria-hidden="true"></i>
							</span>
						</ng-container>
					</div>
					<small class="field-cell-hint">{{ f.hint || '' }}</small>
				</label>
			</div>
		</div>
		<!-- Bestand-Konvertierung als eigene Kachel (filterbar: bestand/sea/konvertieren) -->
		<div *ngIf="!fieldFilter || bestandFilterMatch" class="field-group-card">
			<div class="field-group-header">Bestand</div>
			<div class="field-grid">
				<label class="field-cell">
					<div class="field-cell-row">
						<input class="form-check-input field-cell-check" type="checkbox"
							[checked]="bestandKonvertieren" (change)="bestandKonvertieren = !bestandKonvertieren">
						<span class="field-cell-text">Bestand SEA-konvertieren</span>
					</div>
					<small class="field-cell-hint">Sicher Erkanntes → SEA-Form; Unsichere bleiben gelb markiert. Originaltext bleibt im Freitext.</small>
				</label>
			</div>
		</div>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 3: Operationen -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="step === 'operationen'" class="step-content">
		<h6>Operation pro Feld festlegen</h6>

		<div *ngFor="let f of selectedFieldsList" class="op-card">
			<div class="op-card-header">
				<strong>{{ f.label }}</strong>
				<span class="badge bg-secondary ms-2">{{ f.type }}</span>
			</div>

			<div class="op-card-body">
				<!-- Sonder-UI fuer "Schicht fuer Pflanzenart": Art-Muster + Moose-Preset.
				     Wird OBERHALB der Operation-Auswahl gerendert, weil das Muster die
				     primaere Eingabe ist; die Schicht-Auswahl folgt unten via kind=set. -->
				<div *ngIf="isSchichtForArtField(f.key)" class="art-pattern-block mb-2">
					<label class="form-label small" [for]="'art-pat-' + f.key">
						Art-Muster (case-insensitive Substring; mehrere Arten mit "|" trennen)
					</label>
					<textarea class="form-control form-control-sm"
							  [id]="'art-pat-' + f.key"
							  rows="2"
							  title="Art-Muster"
							  placeholder="Sphagnum|Polytrichum|Dicranum"
							  [(ngModel)]="getConfig(f.key).artPattern"></textarea>
					<div class="form-text d-flex justify-content-between align-items-center mt-1">
						<span>Trifft alle Vegetationszeilen, deren Name eines dieser Wörter enthält.</span>
						<button type="button" class="btn btn-sm btn-outline-secondary"
								title="Vorlage „Moose“ einfügen — gängige Bryophyta-Genera, Zielschicht Moosschicht"
								(click)="applyMoosPreset(f.key)">
							Vorlage „Moose"
						</button>
					</div>
				</div>

				<div class="mb-2">
					<label class="form-label small" [for]="'op-kind-' + f.key">Operation</label>
					<select class="form-select form-select-sm"
							[id]="'op-kind-' + f.key"
							title="Operation auswählen"
							[ngModel]="getConfig(f.key).kind"
							(ngModelChange)="getConfig(f.key).kind = $event; onKindChange(f.key)">
						<option value="">— auswählen —</option>
						<option *ngFor="let k of availableKinds(f)" [value]="k.kind">{{ k.label }}</option>
					</select>
				</div>

				<!-- Set -->
				<div *ngIf="getConfig(f.key).kind === 'set'">
					<label class="form-label small" [for]="'set-' + f.key">Neuer Wert</label>
					<select *ngIf="f.type === 'enum'"
							class="form-select form-select-sm"
							[id]="'set-' + f.key"
							title="Neuer Wert"
							[(ngModel)]="getConfig(f.key).setValue">
						<option *ngFor="let e of f.enumValues" [value]="e.value">{{ e.label }}</option>
					</select>
					<input *ngIf="f.type !== 'enum' && f.type !== 'date'"
						   class="form-control form-control-sm"
						   [id]="'set-' + f.key"
						   [type]="f.type === 'number' ? 'number' : 'text'"
						   title="Neuer Wert"
						   placeholder="Neuer Wert"
						   [(ngModel)]="getConfig(f.key).setValue">
					<!-- Datum wie wd-date-input: Klick ins Feld oeffnet den Kalender, „Heute“ steht rechts daneben. -->
					<div *ngIf="f.type === 'date'" class="input-group input-group-sm flex-nowrap">
						<input class="form-control form-control-sm"
							   [id]="'set-' + f.key"
							   type="date"
							   title="Neuer Wert"
							   [(ngModel)]="getConfig(f.key).setValue"
							   (click)="oeffneKalender($event.target)">
						<button type="button"
								class="btn btn-outline-secondary datum-heute"
								title="Heutiges Datum eintragen"
								(click)="setzeHeute(f.key)">Heute</button>
					</div>
				</div>

				<!-- Clear: nichts zu konfigurieren -->

				<!-- Mapping (exakter Wert) -->
				<div *ngIf="getConfig(f.key).kind === 'mapping'">
					<label class="form-label small" [for]="'map-' + f.key">
						Zuordnungen — der <em>komplette</em> Feldwert wird mit „alt" verglichen
						(eine Regel pro Zeile, Format <code>alt = neu</code>)
					</label>
					<textarea class="form-control form-control-sm"
							  [id]="'map-' + f.key"
							  rows="5"
							  title="Mapping-Text"
							  placeholder="N.O. = Nord-Ost&#10;S.W. = Süd-West"
							  [ngModel]="getConfig(f.key).mappingText"
							  (ngModelChange)="getConfig(f.key).mappingText = $event; onMappingTextChange(f, f.key)"></textarea>
					<!-- Enum-Schutz: bei Dropdown-Feldern darf das „neu"-Ziel nicht ausserhalb der
					     erlaubten Werte liegen — sonst wuerde das Mapping illegale Werte einschleusen.
					     Wir markieren ungueltige Eintraege rot; isConfigComplete blockiert „Weiter"
					     parallel dazu (s. Wizard-TS). -->
					<div *ngIf="f.type === 'enum' && getConfig(f.key).mappingInvalidTargets.length > 0"
						 class="form-text text-danger small mt-1">
						Unzulaessige Ziel-Werte (nicht in der Liste):
						{{ getConfig(f.key).mappingInvalidTargets.join(', ') }}
					</div>
					<div *ngIf="f.type === 'enum'" class="form-text small mt-1">
						Erlaubte Ziel-Werte:
						<code *ngFor="let e of f.enumValues; let last = last">{{ e.value }}<span *ngIf="!last">, </span></code>
					</div>
					<div class="form-check mt-1">
						<input class="form-check-input" type="checkbox"
							   [id]="'pt-' + f.key"
							   title="Unbekannte Werte unveraendert lassen"
							   [(ngModel)]="getConfig(f.key).mappingPassthrough">
						<label class="form-check-label small" [for]="'pt-' + f.key">
							Unbekannte Werte unverändert lassen
						</label>
					</div>
					<div class="form-text mt-1">
						Für <strong>Teilstring</strong>-Ersetzung („nur Stück x → y im Wert ersetzen")
						stattdessen die Operation <em>„Mehrfach-Ersetzen (Teilstring)"</em> wählen.
					</div>
				</div>

				<!-- ReplaceList — sequentielle Teilstring-Ersetzung -->
				<div *ngIf="getConfig(f.key).kind === 'replaceList'">
					<label class="form-label small" [for]="'rl-' + f.key">
						Ersetzungen — jede Regel sucht <em>überall im Wert</em> und ersetzt; Regeln laufen
						<em>der Reihe nach</em> (eine Regel pro Zeile, Format <code>alt = neu</code>)
					</label>
					<textarea class="form-control form-control-sm"
							  [id]="'rl-' + f.key"
							  rows="5"
							  title="Ersetzungs-Liste"
							  [placeholder]="getConfig(f.key).replaceListRegex
								  ? '\\bgmbh\\b = GmbH&#10;m(²|2) = qm'
								  : 'm² = qm&#10;GmbH = Gesellschaft mbH'"
							  [(ngModel)]="getConfig(f.key).replaceListText"></textarea>
					<div class="form-check mt-1">
						<input class="form-check-input" type="checkbox"
							   [id]="'rlre-' + f.key"
							   title="Suche als Regex interpretieren (Flag g, $1 im Ersatztext)"
							   [(ngModel)]="getConfig(f.key).replaceListRegex">
						<label class="form-check-label small" [for]="'rlre-' + f.key">
							Regex verwenden (Suche als Muster, <code>$1</code> im Ersatztext)
						</label>
					</div>
					<div class="form-text mt-1">
						Tipp: Regeln von speziell zu allgemein anordnen — die spätere Regel sieht
						das Ergebnis der früheren.
					</div>
					<details class="small text-muted regex-help mt-2" *ngIf="getConfig(f.key).replaceListRegex">
						<summary class="user-select-none">
							<i class="bi bi-info-circle"></i> Regex-Hilfe &amp; Beispiele (für Einsteiger)
						</summary>
						<ng-container *ngTemplateOutlet="regexHelpBody"></ng-container>
					</details>
				</div>

				<!-- StringTransform -->
				<div *ngIf="getConfig(f.key).kind === 'stringTransform'" class="row g-2">
					<div class="col-md-4">
						<label class="form-label small" [for]="'st-' + f.key">Transformation</label>
						<select class="form-select form-select-sm"
								[id]="'st-' + f.key"
								title="Transformation"
								[(ngModel)]="getConfig(f.key).stringTransform">
							<option value="trim">Whitespace entfernen</option>
							<option value="upper">GROSSBUCHSTABEN</option>
							<option value="lower">kleinbuchstaben</option>
							<option value="prefix">Präfix anfügen</option>
							<option value="suffix">Suffix anfügen</option>
							<option value="replace">Ersetzen</option>
						</select>
					</div>
					<div class="col-md-4" *ngIf="['prefix','suffix','replace'].includes(getConfig(f.key).stringTransform || '')">
						<label class="form-label small" [for]="'st-arg1-' + f.key">
							{{ getConfig(f.key).stringTransform === 'replace' ? 'Suche' : 'Text' }}
						</label>
						<input class="form-control form-control-sm" type="text"
							   [id]="'st-arg1-' + f.key"
							   title="Textargument"
							   placeholder="Text"
							   [(ngModel)]="getConfig(f.key).strArg1">
					</div>
					<div class="col-md-4" *ngIf="getConfig(f.key).stringTransform === 'replace'">
						<label class="form-label small" [for]="'st-arg2-' + f.key">Ersetzen durch</label>
						<input class="form-control form-control-sm" type="text"
							   [id]="'st-arg2-' + f.key"
							   title="Ersatztext"
							   placeholder="Ersatztext"
							   [(ngModel)]="getConfig(f.key).strArg2">
						<div class="form-check mt-1">
							<input class="form-check-input" type="checkbox"
								   [id]="'re-' + f.key"
								   title="Regex verwenden"
								   [(ngModel)]="getConfig(f.key).strRegex">
							<label class="form-check-label small" [for]="'re-' + f.key">
								Regex verwenden
							</label>
						</div>
					</div>
					<div class="col-12" *ngIf="getConfig(f.key).stringTransform === 'replace'">
						<details class="small text-muted regex-help">
							<summary class="user-select-none">
								<i class="bi bi-info-circle"></i> Regex-Hilfe &amp; Beispiele (für Einsteiger)
							</summary>
							<ng-container *ngTemplateOutlet="regexHelpBody"></ng-container>
						</details>
					</div>
				</div>

				<!-- Arithmetic -->
				<div *ngIf="getConfig(f.key).kind === 'arithmetic'" class="row g-2">
					<div class="col-md-6">
						<label class="form-label small" [for]="'ar-op-' + f.key">Operation</label>
						<select class="form-select form-select-sm"
								[id]="'ar-op-' + f.key"
								title="Rechen-Operation"
								[(ngModel)]="getConfig(f.key).arithmeticOp">
							<option value="add">+ addieren</option>
							<option value="sub">− subtrahieren</option>
							<option value="mul">× multiplizieren</option>
							<option value="set">= setzen</option>
							<option value="round">auf N Stellen runden</option>
						</select>
					</div>
					<div class="col-md-6">
						<label class="form-label small" [for]="'ar-val-' + f.key">Wert</label>
						<input class="form-control form-control-sm" type="number"
							   [id]="'ar-val-' + f.key"
							   title="Wert"
							   placeholder="Wert"
							   [(ngModel)]="getConfig(f.key).arithmeticValue">
					</div>
				</div>

				<!-- DateOp -->
				<div *ngIf="getConfig(f.key).kind === 'dateOp'" class="row g-2">
					<div class="col-md-6">
						<label class="form-label small" [for]="'d-op-' + f.key">Datum-Operation</label>
						<select class="form-select form-select-sm"
								[id]="'d-op-' + f.key"
								title="Datum-Operation"
								[(ngModel)]="getConfig(f.key).dateOp">
							<option value="today">auf heute setzen</option>
							<option value="addDays">Tage addieren</option>
							<option value="monthStart">auf Monatsanfang setzen</option>
						</select>
					</div>
					<div class="col-md-6" *ngIf="getConfig(f.key).dateOp === 'addDays'">
						<label class="form-label small" [for]="'d-days-' + f.key">Tage (negativ = rückwärts)</label>
						<input class="form-control form-control-sm" type="number"
							   [id]="'d-days-' + f.key"
							   title="Anzahl Tage"
							   placeholder="Tage"
							   [(ngModel)]="getConfig(f.key).dateDays">
					</div>
				</div>

				<!-- IfThen -->
				<div *ngIf="getConfig(f.key).kind === 'ifThen'" class="if-then-block">
					<div class="row g-2">
						<div class="col-md-4">
							<label class="form-label small" [for]="'if-op-' + f.key">Wenn aktueller Wert</label>
							<select class="form-select form-select-sm"
									[id]="'if-op-' + f.key"
									title="Vergleichsoperator"
									[(ngModel)]="getConfig(f.key).ifCondOp">
								<option *ngFor="let op of ifThenOpOptions(f)" [value]="op.value">{{ op.label }}</option>
							</select>
						</div>
						<div class="col-md-4" *ngIf="!opNeedsNoValue(getConfig(f.key).ifCondOp)">
							<label class="form-label small" [for]="'if-val-' + f.key">{{ opNeedsTwoValues(getConfig(f.key).ifCondOp) ? 'von' : 'Vergleichswert' }}</label>
							<select *ngIf="f.type === 'enum'"
									class="form-select form-select-sm"
									[id]="'if-val-' + f.key"
									title="Vergleichswert"
									[(ngModel)]="getConfig(f.key).ifCondValue">
								<option *ngFor="let e of f.enumValues" [value]="e.value">{{ e.label }}</option>
							</select>
							<input *ngIf="f.type !== 'enum'"
								   class="form-control form-control-sm" type="text"
								   [id]="'if-val-' + f.key"
								   title="Vergleichswert"
								   placeholder="Vergleichswert"
								   [(ngModel)]="getConfig(f.key).ifCondValue">
						</div>
						<div class="col-md-4" *ngIf="opNeedsTwoValues(getConfig(f.key).ifCondOp)">
							<label class="form-label small" [for]="'if-val2-' + f.key">bis</label>
							<input class="form-control form-control-sm" type="text"
								   [id]="'if-val2-' + f.key"
								   title="Obergrenze"
								   placeholder="Obergrenze"
								   [(ngModel)]="getConfig(f.key).ifCondValue2">
						</div>
					</div>
					<div class="row g-2 mt-1">
						<div class="col-md-4">
							<label class="form-label small" [for]="'then-op-' + f.key">dann</label>
							<select class="form-select form-select-sm"
									[id]="'then-op-' + f.key"
									title="Folgeaktion"
									[(ngModel)]="getConfig(f.key).ifThenKind">
								<option value="set">setzen auf</option>
								<option value="clear">leeren</option>
							</select>
						</div>
						<div class="col-md-8" *ngIf="getConfig(f.key).ifThenKind === 'set'">
							<label class="form-label small" [for]="'then-val-' + f.key">neuen Wert</label>
							<select *ngIf="f.type === 'enum'"
									class="form-select form-select-sm"
									[id]="'then-val-' + f.key"
									title="Neuer Wert"
									[(ngModel)]="getConfig(f.key).ifThenValue">
								<option *ngFor="let e of f.enumValues" [value]="e.value">{{ e.label }}</option>
							</select>
							<input *ngIf="f.type !== 'enum'"
								   class="form-control form-control-sm" type="text"
								   [id]="'then-val-' + f.key"
								   title="Neuer Wert"
								   placeholder="Neuer Wert"
								   [(ngModel)]="getConfig(f.key).ifThenValue">
						</div>
					</div>
				</div>

				<!-- onlyIfEmpty Modifier — fuer Sonder-Feld nicht anbieten: Skip-Logik laeuft
				     ueber den Accessor selbst (Sentinel via getValue), Checkbox waere irritierend. -->
				<div class="form-check mt-2"
					 *ngIf="getConfig(f.key).kind && getConfig(f.key).kind !== '' && !isSchichtForArtField(f.key)">
					<input class="form-check-input" type="checkbox"
						   [id]="'oie-' + f.key"
						   title="Nur auf leere Felder anwenden"
						   [(ngModel)]="getConfig(f.key).onlyIfEmpty">
					<label class="form-check-label small" [for]="'oie-' + f.key">
						Nur anwenden, wenn das Feld bisher leer ist (Lücken füllen)
					</label>
				</div>

				<!-- Cross-Field-Bedingungen (where) -->
				<div class="where-block mt-2" *ngIf="getConfig(f.key).kind && getConfig(f.key).kind !== ''">
					<div class="d-flex align-items-center gap-2 mb-1">
						<span class="form-label small mb-0">Zusätzlich nur anwenden, wenn (alle Bedingungen erfüllt):</span>
						<button type="button" class="btn btn-sm btn-outline-secondary"
								(click)="addWhere(f.key)"
								title="Bedingung hinzufügen">+ Bedingung</button>
					</div>
					<div *ngFor="let w of getConfig(f.key).whereConditions; let i = index" class="row g-1 mb-1 align-items-center">
						<div class="col-md-3">
							<select class="form-select form-select-sm"
									[id]="'where-fld-' + f.key + '-' + i"
									title="Bedingungs-Feld"
									[ngModel]="w.field"
									(ngModelChange)="w.field = $event; onWhereFieldChange(f.key, i)">
								<option value="">— Feld wählen —</option>
								<option *ngFor="let opt of whereFieldOptions" [value]="opt.key">{{ opt.label }}</option>
							</select>
						</div>
						<div class="col-md-3">
							<select class="form-select form-select-sm"
									[id]="'where-op-' + f.key + '-' + i"
									title="Vergleichsoperator"
									[ngModel]="w.op"
									(ngModelChange)="w.op = $event; onWhereOpChange(f.key, i)">
								<option *ngFor="let op of whereOpOptions(w.field)" [value]="op.value">{{ op.label }}</option>
							</select>
						</div>
						<div class="col-md-2" *ngIf="!opNeedsNoValue(w.op)">
							<ng-container *ngIf="enumValuesForKey(w.field) as enumOpts; else whereValPlain">
								<select class="form-select form-select-sm"
										[id]="'where-val-' + f.key + '-' + i"
										title="Vergleichswert"
										[(ngModel)]="w.value">
									<option *ngFor="let e of enumOpts" [value]="e.value">{{ e.label }}</option>
								</select>
							</ng-container>
							<ng-template #whereValPlain>
								<input class="form-control form-control-sm" type="text"
									   [id]="'where-val-' + f.key + '-' + i"
									   title="Vergleichswert"
									   [placeholder]="opNeedsTwoValues(w.op) ? 'von' : 'Wert'"
									   [(ngModel)]="w.value">
							</ng-template>
						</div>
						<div class="col-md-2" *ngIf="opNeedsTwoValues(w.op)">
							<input class="form-control form-control-sm" type="text"
								   [id]="'where-val2-' + f.key + '-' + i"
								   title="Obergrenze"
								   placeholder="bis"
								   [(ngModel)]="w.value2">
						</div>
						<div class="col-md-1 text-end">
							<button type="button" class="btn btn-sm btn-outline-danger"
									(click)="removeWhere(f.key, i)"
									title="Bedingung entfernen">×</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 4: Preview -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="step === 'preview'" class="step-content">
		<h6>Vorschau</h6>
		<p *ngIf="previewChangedCount > 0" class="text-muted small">
			<strong>{{ previewChangedCount }}</strong> Punkte werden durch Feld-Operationen geändert.
			Zeilen kannst du abwählen, um einzelne Punkte auszuschließen.
		</p>

		<div *ngIf="bestandKonvertieren && bestandPlan" class="alert alert-info py-2">
			<strong>Bestand-Konvertierung:</strong>
			{{ bestandPlan.konvertierbar }} werden konvertiert, {{ bestandPlan.pruefung }} bleiben zur Prüfung (gelb)
			<span class="text-muted">· {{ bestandPlan.konform }} bereits konform · {{ bestandPlan.keinRecht }} ohne Schreibrecht</span>
		</div>

		<table *ngIf="bestandKonvertieren && bestandPreviewRows.length > 0" class="table table-sm preview-table">
			<thead>
				<tr><th>Punkt</th><th>Bestand alt</th><th>Bestand neu (SEA)</th></tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of bestandPreviewRows | slice:0:200">
					<td>{{ r.nummer }}</td>
					<td class="text-muted">{{ r.alt }}</td>
					<td><strong>{{ r.neu }}</strong></td>
				</tr>
			</tbody>
		</table>
		<p *ngIf="bestandPreviewRows.length > 200" class="text-muted small">
			… und {{ bestandPreviewRows.length - 200 }} weitere konvertierbare Bestände.
		</p>

		<div *ngIf="preview.length === 0 && !(bestandKonvertieren && bestandPlan && bestandPlan.konvertierbar > 0)" class="alert alert-warning">
			Keine Aktionen — bitte zurückgehen und Operation prüfen.
		</div>

		<table *ngIf="previewChangedCount > 0" class="table table-sm preview-table">
			<thead>
				<tr>
					<th class="col-checkbox"><span class="visually-hidden">Auswahl</span></th>
					<th>Punkt</th>
					<th>Feld</th>
					<th>Alt</th>
					<th>Neu</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of preview">
					<tr *ngIf="row.diffs.length === 0" class="row-unchanged">
						<td></td>
						<td>{{ row.pointLabel || row.pointId }}</td>
						<td colspan="3" class="text-muted small">keine Änderung</td>
					</tr>
					<tr *ngFor="let diff of row.diffs; let first = first"
						[class.row-skipped]="diff.skipped"
						[class.row-excluded]="excludedPreviewPointIds.has(row.pointId)">
						<td *ngIf="first" [attr.rowspan]="row.diffs.length">
							<input type="checkbox" class="form-check-input"
								   title="Punkt ein-/ausschalten"
								   [checked]="!excludedPreviewPointIds.has(row.pointId)"
								   [disabled]="!row.willChange"
								   [attr.aria-label]="'Punkt ' + (row.pointLabel || row.pointId) + ' ein-/ausschalten'"
								   (change)="togglePreviewRow(row.pointId)">
						</td>
						<td *ngIf="first" [attr.rowspan]="row.diffs.length">
							{{ row.pointLabel || row.pointId }}
						</td>
						<td>{{ diff.fieldLabel }}</td>
						<td>
							<code>{{ formatValue(diff.oldValue) }}</code>
						</td>
						<td>
							<span *ngIf="diff.skipped" class="text-muted small">
								übersprungen: {{ diff.reason }}
							</span>
							<code *ngIf="!diff.skipped">{{ formatValue(diff.newValue) }}</code>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 5: Ausführung -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="step === 'ausfuehrung'" class="step-content">
		<h6>Wird angewendet…</h6>
		<ngb-progressbar type="primary" [value]="progressTotal ? (progressDone / progressTotal * 100) : 0"
						 [animated]="true" [striped]="true">
			{{ progressDone }} / {{ progressTotal }}
		</ngb-progressbar>
		<p class="text-muted small mt-2">Aktueller Punkt: {{ currentPointId }}</p>
	</section>

	<!-- -------------------------------------------------- -->
	<!-- Step 6: Abgeschlossen -->
	<!-- -------------------------------------------------- -->
	<section *ngIf="step === 'abgeschlossen' && report" class="step-content">
		<h6>Fertig</h6>
		<div *ngIf="report.totalPoints > 0" class="alert alert-success">
			<strong>{{ report.changedPoints }}</strong> von {{ report.totalPoints }} Punkten per Feld-Operation aktualisiert.
			<span *ngIf="report.unchangedPoints > 0"> · {{ report.unchangedPoints }} unverändert.</span>
		</div>
		<div *ngIf="bestandGespeichert > 0" class="alert alert-info">
			<strong>Bestand SEA-konvertiert:</strong> {{ bestandPlan?.konvertierbar ?? 0 }} in SEA-Form gebracht,
			{{ bestandPlan?.pruefung ?? 0 }} bleiben zur Prüfung (gelb) — {{ bestandGespeichert }} Punkte gespeichert.
			<div class="small text-muted mt-1">
				Der Originaltext bleibt im Freitext-Feld; pro Punkt über „Rückgängig" im Bestand-Bereich umkehrbar.
			</div>
		</div>
		<div *ngIf="report.errors.length > 0" class="alert alert-danger">
			<strong>Fehler bei {{ report.errors.length }} Punkten:</strong>
			<ul class="mb-0">
				<li *ngFor="let e of report.errors">
					<strong>{{ e.pointId }}</strong>: {{ e.message }}
				</li>
			</ul>
		</div>
		<div *ngIf="report.skipNotes.length > 0" class="alert alert-warning">
			<strong>Hinweise bei {{ report.skipNotes.length }} Punkten:</strong>
			<ul class="mb-0">
				<li *ngFor="let s of report.skipNotes">
					<strong>{{ s.pointId }}</strong>:
					<span *ngFor="let r of s.reasons; let last = last">{{ r }}<span *ngIf="!last">; </span></span>
				</li>
			</ul>
		</div>
		<p *ngIf="report.changedPoints > 0" class="text-muted small">
			Batch-ID: <code>{{ report.batchId }}</code><br>
			Die Feld-Änderungen sind in der Historie jedes Punktes dokumentiert und können dort rückgängig gemacht werden.
		</p>
	</section>
</div>

<div class="modal-footer">
	<button *ngIf="step !== 'ausfuehrung' && step !== 'abgeschlossen'"
			type="button" class="btn btn-outline-secondary" (click)="cancel()">
		Abbrechen
	</button>
	<button *ngIf="['felder','operationen','preview'].includes(step)"
			type="button" class="btn btn-outline-secondary" (click)="goBack()">
		← Zurück
	</button>
	<!-- 'auswahl' hat keinen Footer-Weiter-Button mehr: dort treiben die drei Pfad-Karten
	     die Aktion (Pfad 1 = Weiter, Pfad 2/3 = eigenständige Läufe). -->
	<button *ngIf="['felder','operationen'].includes(step)"
			type="button" class="btn btn-primary"
			[disabled]="!canGoNext()"
			(click)="goNext()">
		Weiter →
	</button>
	<button *ngIf="step === 'preview'"
			type="button" class="btn btn-danger"
			[disabled]="!canGoNext()"
			(click)="goNext()">
		Ausführen ({{ previewChangedCount }} Feld<span *ngIf="bestandKonvertieren && bestandPlan">, {{ bestandPlan.konvertierbar }} Bestand</span>)
	</button>
	<button *ngIf="step === 'abgeschlossen'"
			type="button" class="btn btn-primary" (click)="close()">
		Schließen
	</button>
</div>

<!-- Regex-Hilfe — wird sowohl von String-Transformation/„Ersetzen" als auch von
     „Mehrfach-Ersetzen (Teilstring)" ausgegeben. Hier einmal definiert, an beiden
     Stellen via *ngTemplateOutlet referenziert. -->
<ng-template #regexHelpBody>
	<div class="mt-2 p-2 bg-light rounded">

		<div class="mb-2">
			<strong>Was ist „Regex"?</strong>
			Ein <em>regulärer Ausdruck</em> ist ein Suchmuster, das Zeichen, Positionen und Wiederholungen beschreibt.
			<br>
			<strong>Ohne</strong> Häkchen <em>„Regex verwenden"</em> wird wörtlich gesucht und ersetzt — keine Sonderzeichen-Fallen.
			<strong>Mit</strong> Häkchen gelten alle Operatoren unten und Capture-Groups <code>(…)</code> sind verfügbar.
			Ersetzt wird immer <strong>global</strong> — alle Treffer pro Wert.
		</div>

		<div class="mb-2">
			<strong>1 · Anker — wo im Wert soll es matchen?</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>^</code> Anfang &mdash; <code>^08-</code> matcht „08-…" nur am Anfang</li>
				<li><code>$</code> Ende &mdash; <code>-2026$</code> matcht „…-2026" nur am Ende</li>
				<li><code>\b</code> Wortgrenze &mdash; <code>\bWeg\b</code> matcht „Weg" allein, nicht in „Wegweiser"</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>2 · Zeichenklassen — welche Zeichen?</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>\d</code> eine Ziffer 0–9 &mdash; <code>\d\d\d\d</code> matcht „2026"</li>
				<li><code>\D</code> keine Ziffer (Gegenteil von <code>\d</code>)</li>
				<li><code>\w</code> Wortzeichen (a–z, A–Z, 0–9, _)</li>
				<li><code>\s</code> Whitespace (Leerz., Tab, Zeilenumbruch)</li>
				<li><code>.</code> ein beliebiges Zeichen &mdash; für wörtlichen Punkt: <code>\.</code></li>
				<li><code>[abc]</code> eines aus a, b oder c</li>
				<li><code>[a-z]</code> Bereich von a bis z</li>
				<li><code>[^0-9]</code> alles AUSSER Ziffern (das <code>^</code> in eckigen Klammern bedeutet „nicht")</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>3 · Wiederholung — wie oft?</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>?</code> 0- oder 1-mal (optional) &mdash; <code>colou?r</code> matcht „color" und „colour"</li>
				<li><code>*</code> 0 oder mehr &mdash; <code>\s*</code> beliebig viele Leerzeichen, auch keine</li>
				<li><code>+</code> 1 oder mehr &mdash; <code>\d+</code> mind. eine Ziffer</li>
				<li><code>&#123;3&#125;</code> genau 3-mal &mdash; <code>\d&#123;4&#125;</code> exakt 4 Ziffern</li>
				<li><code>&#123;2,4&#125;</code> 2 bis 4-mal &mdash; <code>&#123;2,&#125;</code> mindestens 2-mal</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>4 · Gruppen &amp; Alternative</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>(...)</code> <em>Capture-Group</em> &mdash; der Inhalt landet im Ersatztext in <code>$1</code>, <code>$2</code>, … (in Reihenfolge des Auftretens)</li>
				<li><code>(?:...)</code> nicht erfassende Gruppe (kein <code>$1</code>) &mdash; nur zum Bündeln</li>
				<li><code>a|b</code> a ODER b &mdash; <code>(08|12)-</code> matcht „08-" oder „12-"</li>
				<li><code>(?=...)</code> Lookahead &mdash; muss folgen, wird aber NICHT ersetzt</li>
				<li><code>(?!...)</code> negativer Lookahead &mdash; darf NICHT folgen</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>5 · Sonderzeichen escapen</strong>
			Mit <code>\</code> davor verlieren sie ihre Sonderbedeutung. Pflicht für: <code>. + * ? ^ $ ( ) [ ] &#123; &#125; | \</code>
			&mdash; z.B. <code>\.</code> wörtlicher Punkt, <code>\(</code> wörtliche Klammer, <code>\\</code> wörtlicher Backslash.
		</div>

		<div class="mb-2">
			<strong>6 · Im Ersetzungstext</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>$1</code>, <code>$2</code>, … die eingefangenen Gruppen in Reihenfolge</li>
				<li><code>$&amp;</code> der gesamte Treffer</li>
				<li><code>$$</code> ein wörtliches <code>$</code>-Zeichen</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>7 · Tokens — Werte aus anderen Feldern einsetzen</strong>
			<br>
			<em>Nur im Ersatztext, nicht in der Suche!</em>
			Mit <code>{{ regexHelp.tokenSyntax }}</code> wird der Wert dieses Feldes vom jeweiligen Punkt eingesetzt — z.B.
			<code>{{ regexHelp.tokenForstamt }}</code>, <code>{{ regexHelp.tokenRevier }}</code>, <code>{{ regexHelp.tokenNummer }}</code>.
			Punkte mit leerem Feld werden mit Begründung übersprungen (sichtbar in der Vorschau).
		</div>

		<div class="mb-2">
			<strong>8 · Filter — Tokens vor dem Einsetzen transformieren</strong>
			<br>
			<code>{{ regexHelp.tokenWithFilterSyntax }}</code> filtert den Feldwert vor dem Einsetzen. Verfügbar:
			<ul class="list-unstyled ps-3 mb-0">
				<li><code>|nr</code> &mdash; extrahiert die führende 2-stellige Nummer aus „08 Müllrose" &rarr; <code>08</code>. Ohne führende Nummer wird der Punkt übersprungen.</li>
			</ul>
		</div>

		<div class="mb-2">
			<strong>9 · Komplette Beispiele</strong>
			<ul class="list-unstyled mb-0 ps-2">
				<li class="mb-1">a) <strong>Forstamt-/Reviernummer + 4-stelliges Jahr</strong>
					(bei Forstamt „08 Müllrose", Revier „03 Reichenkam": <code>039-25</code> &rarr; <code>08-03-039-2025</code>):
					Suche <code>{{ regexHelp.regexJahrSearch }}</code> &rarr; Ersetzen <code>{{ regexHelp.exampleReplaceForstamtRevierMitNr }}</code></li>
				<li class="mb-1">b) <strong>Forstamt-/Revier-Volltext einsetzen</strong> (ohne <code>|nr</code>):
					Ersetzen <code>{{ regexHelp.exampleReplaceForstamtRevier }}</code> (voller Feldinhalt inkl. Name)</li>
				<li class="mb-1">c) <strong>Jahres-Suffix umstellen</strong> (-2026 &rarr; -2027):
					Suche <code>-2026$</code> &rarr; Ersetzen <code>-2027</code></li>
				<li class="mb-1">d) <strong>Beliebiges 4-stelliges Jahr austauschen</strong>:
					Suche <code>-\d&#123;4&#125;$</code> &rarr; Ersetzen <code>-2027</code></li>
				<li class="mb-1">e) <strong>Präfix „cp" vor lfd. Nr.</strong> (<code>039-25</code> &rarr; <code>cp039-25</code>):
					Suche <code>^(\d+)</code> &rarr; Ersetzen <code>cp$1</code></li>
				<li class="mb-1">f) <strong>Konstanter Präfix vor jeden Wert</strong>:
					Suche <code>^(.*)$</code> &rarr; Ersetzen <code>FA-FR-$1</code> (Kürzel wörtlich tippen)</li>
				<li class="mb-1">g) <strong>Einstellige Zahl auf zwei Stellen padden</strong> (<code>8-08-…</code> &rarr; <code>08-08-…</code>):
					Suche <code>^(\d)(?=-)</code> &rarr; Ersetzen <code>0$1</code></li>
				<li class="mb-1">h) <strong>Führende Nullen entfernen</strong> (<code>0007</code> &rarr; <code>7</code>):
					Suche <code>^0+(\d+)</code> &rarr; Ersetzen <code>$1</code></li>
				<li class="mb-1">i) <strong>Whitespace um Bindestriche entfernen</strong> („08 - 08 - 96" &rarr; „08-08-96"):
					Suche <code>\s*-\s*</code> &rarr; Ersetzen <code>-</code></li>
				<li class="mb-1">j) <strong>T1 mit Unterstrich abtrennen</strong> („OstT1" &rarr; „Ost_T1"):
					Suche <code>(T1)</code> &rarr; Ersetzen <code>_$1</code></li>
				<li class="mb-1">k) <strong>Bindestriche &rarr; Unterstriche</strong> (ohne Regex):
					Suche <code>-</code> &rarr; Ersetzen <code>_</code></li>
			</ul>
		</div>

		<div>
			<strong>Hinweise:</strong>
			<ul class="list-unstyled ps-3 mb-0">
				<li>&bull; Vorschau in Schritt 4 <strong>immer</strong> prüfen, bevor angewendet wird.</li>
				<li>&bull; Tokens (<code>{{ regexHelp.tokenSyntax }}</code>) gelten nur im Ersatztext, nicht im Suchmuster.</li>
				<li>&bull; Ohne <code>^</code> oder <code>$</code> matcht das Pattern überall im Wert.</li>
				<li>&bull; Bei ungültigem Regex wird der Punkt mit Begründung übersprungen — nichts wird zerstört.</li>
				<li>&bull; Nur Teilmenge betroffen? Zusätzlich Cross-Field-Bedingung („Zusätzlich nur anwenden, wenn …") setzen.</li>
			</ul>
		</div>

		<div class="mt-2">
			<a href="javascript:void(0)" (click)="openHandbuchRegex()"
			   title="Schließt den Editor und öffnet die ausführliche Regex-Anleitung im Handbuch">
				<i class="bi bi-book"></i>
				Ausführliche Beschreibung im Handbuch öffnen (Abschnitt <em>Batch-Editor &rarr; Regex</em>)
			</a>
			<div class="text-warning small mt-1">
				<i class="bi bi-exclamation-triangle"></i>
				<strong>Achtung:</strong> Der Klick schließt die Sammelbearbeitung.
				Deine bisherigen Eingaben gehen dabei verloren — wenn du noch
				keine Vorschau geprüft hast, notiere dir vorher kurz, was du
				eingestellt hattest. Nach dem Lesen im Handbuch musst du den
				Editor wieder neu öffnen.
			</div>
		</div>
	</div>
</ng-template>
